module.exports = __webpack_public_path__ + "static/media/colorfulHorizontalLine.6ba263c5.svg";